module.exports = __webpack_public_path__ + "static/media/cases_ilustracoes_new01.924fb5c6.jpg";